import { render, staticRenderFns } from "./StorageModalForm.vue?vue&type=template&id=953adbe4"
import script from "./StorageModalForm.vue?vue&type=script&lang=js"
export * from "./StorageModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports